module.exports = __webpack_public_path__ + "img/emoji_56.ccf670df.png";